export default { DEFAULT_FONT_SIZE: 14 }
